export async function getExportStatus(_, payload)
{
  const {errResponse, data: responseData} = await this.$adminRepositories.tool.getExportStatus(payload)
  if (!errResponse && responseData.success) {
    return responseData.data
  } else return false;
}

export async function exportData(_, payload)
{
  const response = await this.$adminRepositories.tool.exportData(payload)
  return response.data;
}

export async function download(_, payload)
{
  return this.$adminRepositories.tool.download(payload)
}

export async function importData(_, payload)
{
  return this.$adminRepositories.tool.importData(payload)
}

export async function confirmImport(_, payload)
{
  return this.$adminRepositories.tool.confirmImport(payload)
}